import BaseApiInstance from './base';
const BASE_URL = '/members';

export const getMemberDetailApi = async memberId => {
  const response = await BaseApiInstance.get(`${BASE_URL}/${memberId}`);
  return response;
};

export const updateDocumentStatusApi = async (id, payload) => {
  const response = await BaseApiInstance.patch(
    `${BASE_URL}/${id}/document-status`,
    payload,
  );
  return response;
};

export const updateTshirtSizeApi = async ({ id, data }) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${id}/tshirt-size`,
    data,
  );
  return response;
};

export const updateBoardingStatusApi = async ({ id, data }) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${id}/boarding-status`,
    data,
  );
  return response;
};

export const updateMemberApi = async ({ id, data }) => {
  const response = await BaseApiInstance.put(`${BASE_URL}/${id}`, data);
  return response;
};

export const transferMealApi = async ({ id, data }) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${id}/transfer-meal`,
    data,
  );
  return response;
};

export const deleteMealApi = async id => {
  const response = await BaseApiInstance.delete(`${BASE_URL}/${id}/meal`);
  return response;
};

export const getNotesApi = async ({ memberId, params }) => {
  const response = await BaseApiInstance.get(`${BASE_URL}/${memberId}/notes`, {
    params,
  });
  return response;
};

export const createNoteApi = async ({ memberId, data }) => {
  const response = await BaseApiInstance.post(
    `${BASE_URL}/${memberId}/notes`,
    data,
  );
  return response;
};

export const updateNoteApi = async ({ memberId, id, data }) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${memberId}/notes/${id}`,
    data,
  );
  return response;
};

export const updatePinStatusApi = async ({ memberId, id, data }) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${memberId}/notes/${id}/update-pin`,
    data,
  );
  return response;
};

export const deleteNoteApi = async ({ memberId, id }) => {
  const response = await BaseApiInstance.delete(
    `${BASE_URL}/${memberId}/notes/${id}`,
  );
  return response;
};

export const updateTagApi = async ({ id, data }) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${id}/update-tag`,
    data,
  );
  return response;
};

export const getTagsByMemberIdApi = async memberId => {
  const response = await BaseApiInstance.get(`${BASE_URL}/${memberId}/tags`);
  return response;
};

export const updateTagStateApi = async (memberId, tagId, data) => {
  const response = await BaseApiInstance.put(
    `${BASE_URL}/${memberId}/tags/${tagId}`,
    data,
  );
  return response;
};

export const createBikeOrderApi = async memberId => {
  const response = await BaseApiInstance.post(
    `${BASE_URL}/${memberId}/bike-orders`,
  );
  return response;
};

export const deleteBikeOrderApi = async (memberId, orderId) => {
  const response = await BaseApiInstance.delete(
    `${BASE_URL}/${memberId}/bike-orders/${orderId}`,
  );
  return response;
};
